<!-- 未完成： 按钮权限配置 -->
<template lang="html">
  <div class="main" v-if="isRelation">
    <!-- <h2
      v-if="title"
      class="title">
      {{title}}
    </h2> -->
    <div class="table-top clearfix">
      <ButtonList
        v-if="toolbarList && toolbarList.length > 0"
        class="toolbar"
        :buttonList="toolbarList"
      />
       <div class="button-wrap toolbar">
        <button type="button" class="btn btn-default btn-" @click="exportCounter">
          <span class="btn-icon">
            <i class="iconfont icon-export"></i>
          </span>
          导出计量设备
        </button>
      </div>
      <FilterBox
        v-if="filterInitList && filterInitList.length > 0"
        class="filter-box"
        :columns="columns"
        :filterList="filterInitList"
        :filterBy="filterBy"
        @changeFilterBy="changeFilterBy"
      />
    </div>
      <!-- 采集器 -->
    <div class="row flexBody">
      <div class="col-md-2" ref="menuLeft">
        <h5>所属区域 <small style="color: #128aea"></small></h5>
        <div class="telnetMenu">
          <el-input
            placeholder="输入关键字进行过滤"
            style="margin-bottom: 3px"
            v-model="filterTreeText">
          </el-input>
          <el-tree
            class="filter-tree"
            ref="deviceTree"
            node-key="id"
            :highlight-current="true"
            :data="treeData"
            :props="defaultProps"
            :filter-node-method="filterTreeNode"
            @node-click="getTreeData">
          </el-tree>
        </div>
      </div>
      <div class="col-md-10">
        <div class="headerBar">
          <el-upload
            accept=".xls,.xlsx"
            name="uploadFile"
            :action="action"
            :show-file-list="false"
            :on-success="renderData"
            :headers="uploadHeader"
            :before-upload="beforeUpload">
            <el-tooltip content="只能上传xls或xlsx文件" :enterable="false" placement="top">
              <el-button class="header-bottom" icon="plus" size="small" type="primary">批量导入</el-button>
            </el-tooltip>
          </el-upload>
          <el-button class="header-bottom" size="small" @click="downloadCSV">
            下载导入模板
            <!-- <a :href="downLink" class="download" download="计量器批量导入模板.xls">下载导入模板</a> -->
          </el-button>
          <el-button size="small" class="header-bottom" icon="delete" @click="handelDeleteAll">批量删除</el-button>
          <el-date-picker
            style="margin: 10px 10px 10px 0;"
            v-model="exportDate"
            type="datetimerange"
            range-separator=" ~ "
            :clearable="false"
            size="small"
            start-placeholder="开始时间"
            end-placeholder="结束时间">
          </el-date-picker>
          <el-button class="header-bottom" size="small" @click="exportCounterSelect">
            导出抄表数据
          </el-button>
        </div>
        <DataTable
          ref="dataTable"  v-loading="loading2" element-loading-text="拼命上传中"
          class="table-wrapper telnetTable"
          mainColumn="name"
          longColumn="name"
          :isLoading="isLoading"
          :columns="columns"
          :operationList="operationList"
          :operationWidth="115"
          :orderBy="orderBy"
          :orderByInit="orderByInit"
          :tableList="tableCountList"
          :tableData="tableCountData"
          :tableWrapperWidth="tableWrapperWidth"
          @checkGroupValue="checkGroupValue"
          @changeOrderBy="changeOrderBy"
        ></DataTable>
      </div>
    </div>
    <div class="table-footer">
      <ColumnFilter
        class="column-filter"
        :openDirection="2"
        :columnsObject="columns"
        :tableList="tableCountList"
        :columnGroupBy="columnGroupBy"
        :tableFullList="tableFullList"
        @grandSonEvent="afterChangeColumn"
      ></ColumnFilter>
      <div class="page">
        <el-pagination
          class="pagination"
          layout="total, sizes, prev, pager, next"
          :page-sizes="[10, 25, 50, 100]"
          :page-size="pageSize"
          :current-page="pageIndex"
          :total="recordsFiltered"
          @size-change="pageSizeChange"
          @current-change="pageIndexChange">
        </el-pagination>
      </div>
    </div>
    <SmartDialog
      v-if="dialogShow"
      v-model="dialogVisible"
      :size="dialogSize"
      :title="dialogLabel">
      <SmartForm
        labelPosition="right"
        btnPosition="center"
        :btnLabel="false"
        :labelSize="4"
        :formList="dialogFormList"
        :values="dialogFormValues"
        :columns="isUpdateDialog? updateColumns: columns"
        :buttonList="dialogButtonList"
        :createFormValues="createFormValues"
        :formEnterIndex="0">
          <div class="form-group row col-xl-12" style="margin-left:-1px">
            <label class="col-form-label text-sm-right col-sm-2 col-form-label-6">
              用水户
            </label>
            <div class="col-sm-10">
              <multiselect
                v-model="dialogFormValues.userValue"
                ref="userMultiform"
                class="userMultiform"
                placeholder="搜索用水户/ 户号 / 地址 / 电话 / 固话 "
                label="hno"
                track-by="hno"
                :loading="searchLoading"
                :options="userOptions"
                :option-height="120"
                :custom-label="customLabel"
                :show-labels="false"
                :searchable="true"
                :options-limit="1000"
                :max-height="600"
                :internal-search="false"
                :show-no-results="showNoResult"
                :hide-selected="false"
                @search-change="getUserOptions">
                <template slot="option" slot-scope="props">
                  <el-row v-if="userOptions.length">
                    <el-col :span="6" class="multOption"
                      v-for="item in userMultList"
                      :key="item.label">{{item.label}}: {{props.option[item.value]}}</el-col>
                  </el-row>
                </template>
                <span slot="noResult">暂无搜索结果</span>
              </multiselect>
              <!-- <div class="error" v-show="isNoWaterUser">请选择用水户</div> -->
            </div>
          </div>
      </SmartForm>
    </SmartDialog>
  </div>
</template>

<script>
import axios from 'axios'
import { debounce, cloneDeep } from 'lodash'
import { pinyinInitial } from 'hanyu-pinyin'
import { mapGetters } from 'vuex'
import {treeFormat} from '@/utils/common.js'

import columns from './columns.js'
import unEditColumns from './unEditColumns.js'
import DataTable from '@/components/DataTable'
import ButtonList from '@/components/ButtonList'
import SmartDialog from '@/components/SmartDialog'
import SmartForm from '@/components/SmartForm'
import SmartFormItem from '@/components/SmartForm/SmartFormItem'
import FilterBox from '@/components/FilterBox'
import Multiselect from 'vue-multiselect'

import { httpHeader, fetch, fetchList, fetchCreate, fetchUpdate, fetchRelation } from '@/utils/api'
// import { fetch, fetchCreate, fetchUpdate } from '@/utils/api'
import { valueFormat, URL, API } from '@/utils/common'

import { toolbarCreate } from '@/containers/DataTablePage/toolbar'
import { operationUpdate, operationDelete } from '@/containers/DataTablePage/operation'
import { checkActions, expire } from '@/utils/auth'
import ColumnFilter from '@/containers/DataTablePage/columnFilter'

export default {
  name: 'Counter',
  components: {
    DataTable,
    ButtonList,
    SmartDialog,
    SmartForm,
    SmartFormItem,
    ColumnFilter,
    FilterBox,
    Multiselect
  },
  data () {
    const hasUpdate = checkActions('/nb/account/update')
    const hasDelete = checkActions('/nb/account/delete')
    const that = this
    const columnsKeys = Object.keys(columns)
    columnsKeys.map(key => {
      columns[key].width = columns[key].width || 180
    })
    const relationKeys = columnsKeys.filter(key => columns[key].relation).map(key => columns[key].relation)
    const userformList = ['hname', 'hno', 'phone', 'mobile', 'addr']
    // const userValueInit = {hname: '', hno: '', phone: '', mobile: '', addr: ''}
    return {
      intervalId: '',
      dialogTableVisible: 1,
      uploadHeader: httpHeader({
        headers: { 'Gddx-Access-AppId': 'web' }
      }, this.$moment().format('x')),
      action: `${URL}${API}/nb/counter/batch`,
      downLink: `${URL}/counter-tmp.xls`,
      valueCheckAll: [],
      orderByInit: [{name: 'createTime', sort: 'desc'}],
      orderBy: [],
      filterTreeText: '',
      title: '计量设备管理',
      label: '计量设备',
      loadingMult: true,
      loading2: false,
      isRelation: false,
      isLoading: false,
      searchLoading: false,
      dialogVisible: false,
      userDialogVisable: false,
      isUpdateDialog: false,
      areaId: '',
      leftMenuWidth: 0,
      pageSize: Number(this.$route.query.pageSize) || 10,
      pageIndex: Number(this.$route.query.pageIndex) || 1,
      recordsFiltered: 0,
      recordsTotal: 0,
      dialogSize: 'lg',
      dialogLabel: '计量设备',
      resource: '/nb/counter',
      filterBy: [],
      isNoWaterUser: false,
      dialogFormValues: {},
      createFormValues: {
        exceptSwitch: ''
      },
      exportDate: [new Date(new Date().toLocaleDateString()), new Date()],
      toolbar: [{
        ...toolbarCreate,
        label: '新增计量设备',
        isShow () {
          return checkActions('/system/account/create')
        },
        funcProps: {
          tablePage: this
        },
        func ({funcProps}) {
          const { table } = funcProps
          table.isUpdateDialog = false
          table.dialogLabel = '新增' + table.label
          table.dialogFormValues = {}
          table.dialogFormList = table.createList
          table.dialogButtonList = table.createButtonList
          table.userValue = ['hname', 'hno', 'phone', 'mobile', 'addr']
          table.dialogVisible = true
        }
      }],
      operation: [
        {
          ...operationUpdate,
          isShow () {
            return hasUpdate
          },
          func ({funcProps}) {
            const { table, data } = funcProps
            console.log(table)
            const labelName = table.labelName ? '【' + data[table.labelName] + '】' : ''
            table.dialogLabel = '编辑' + table.label + labelName
            table.isUpdateDialog = true
            table.dialogFormValues = cloneDeep(data)
            userformList.map(key => { table.userValue[key] = data[key] ? data[key] : '' })
            table.dialogFormList = table.updateList
            table.dialogButtonList = table.updateButtonList
            table.dialogVisible = true
          }
        }, {
          ...operationDelete,
          isShow () {
            return hasDelete
          }
        }],
      tableCollectList: ['name', 'code', 'installTimeStr', 'creator'],
      tableCountList: ['checkBox', 'code', 'hno', 'hname', 'batteryLevel', 'signalStrength', 'caliber', 'last_image', 'last_data', 'last_time', 'installTimeStr', 'addr', 'phone', 'mobile', 'simCard'],
      tableFullList: ['checkBox', 'name', 'code', 'hno', 'hname', 'batteryLevel', 'signalStrength', 'caliber', 'last_image', 'last_data', 'last_time', 'installTimeStr', 'addr', 'phone', 'mobile', 'code', 'collectorCode', 'port', 'electric', 'largeType', 'smallType', 'simCard', 'deviceType', 'collectorCode', 'repeaterCode', 'creatorId'],
      filterInitList: ['hno', 'hname', 'code'],
      filterFullList: ['hno', 'hname', 'code'],
      filterByAlways: {},
      updateList: ['productType', 'code', 'name', 'hno', 'hname', 'areaId', 'simCard', 'installTime', 'copyTimes', 'caliber', 'exceptSwitch'],
      createList: ['productType', 'code', 'name', 'hno', 'hname', 'areaId', 'simCard', 'installTime', 'copyTimes', 'caliber', 'exceptSwitch'],
      relationKeys: relationKeys,
      treeData: [],
      tableCountData: [],
      columns: {
        ...columns,
        name: {
          label: '设备名称',
          width: 150,
          sort: true,
          filter: {
            type: 'input',
            like: true,
            width: 100
          },
          form: {
            type: 'input',
            size: 10,
            rules: [{
              type: 'required',
              message: '请输入设备名称'
            }],
            columnSize: [{
              type: 'md',
              size: 6
            }, {
              type: 'sm',
              size: 12
            }]
          }
        },
        last_time: {
          label: '抄表时间',
          width: 175,
          type: 'time',
          dataType: 'YYYY-MM-DD',
          filter: {
            type: 'date',
            width: 200
          }
        },
        last_image: {
          label: '抄表行码',
          width: 130,
          type: 'custom',
          html: true,
          magnifying: {
            height: '80px',
            width: '130'
          },
          style: {
            textAlign: 'center'
          },
          customRender (data, full, index) {
            return `<img src="${data}" style="height:24px"></img>`
          }
        },
        last_data: {
          label: '抄表数',
          width: 100,
          style: {
            textAlign: 'center'
          },
          form: {
            type: 'input',
            rules: [{ type: 'numeric', message: '输入正确的行码' }]
          }
        },
        code: {
          label: '设备编号',
          width: 150,
          sort: true,
          filter: {
            type: 'input',
            like: true,
            width: 100
          },
          form: {
            type: 'input',
            size: 12,
            rules: [{ type: 'required', message: '请输入设备编号' },
              {type: 'alphaNum', message: '输入正确设备编号，允许英文、数字'}],
            columnSize: [{
              type: 'md',
              size: 6
            }, {
              type: 'sm',
              size: 12
            }]
          }
        },
        checkBox: {
          label: '',
          width: 60,
          html: true,
          checkBox: true,
          minLength: 999,
          style: {
            'text-align': 'center'
          }
        }
      },
      updateColumns: {
        ...columns,
        ...unEditColumns,
        name: {
          label: '设备名称',
          width: 150,
          filter: {
            type: 'input',
            like: true,
            width: 150
          },
          form: {
            type: 'input',
            size: 10,
            rules: [{
              type: 'required',
              message: '请输入设备名称'
            }],
            columnSize: [{
              type: 'md',
              size: 6
            }, {
              type: 'sm',
              size: 12
            }]
          }
        }
      },
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      createButtonList: [{
        name: 'submit',
        label: '新增',
        type: 'complete',
        validate: true,
        funcProps: {
          table: this
        },
        func ({funcProps}) {
          const { form, button } = funcProps
          button.loading = true
          fetchCreate({
            resource: that.resource,
            data: form.formValues
          })
          .then(data => {
            button.loading = false
            if (data) {
              that.getData(that.areaId)
              that.dialogVisible = false
            }
          })
        }
      }],
      updateButtonList: [{
        name: 'submit',
        label: '编辑',
        type: 'complete',
        validate: true,
        funcProps: {
          form: this,
          table: this,
          el: this
        },
        func ({funcProps}) {
          const { form, table, button } = funcProps
          button.loading = true
          const userFormValues = table.$refs.userMultiform ? table.$refs.userMultiform.value : {}
          const id = form.formValues.id ? form.formValues.id : table.userFormId
          // console.info('fetchUpdate:', Object.assign({}, form.formValues, userFormValues))
          fetchUpdate({
            resource: that.resource,
            id: id,
            data: Object.assign({}, form.formValues, userFormValues)
          })
          .then(data => {
            button.loading = false
            if (data) {
              that.getData(this.areaId)
              that.dialogVisible = false
            }
          })
        } /* 编辑表单的提交事件 */
      }],
      showNoResult: false,
      userMultList: [{label: '户号', value: 'hno'},
      {label: '户名', value: 'hname'},
      {label: '固话', value: 'phone'},
      {label: '手机', value: 'mobile'},
      {label: '地址', value: 'addr'}],
      userOptions: [],
      userFormValues: {},
      userValue: {hname: '编辑用水户', hno: '户号', phone: '手机', mobile: '固话', addr: '地址'} // 默认显示multicSelect第一个数据
    }
  },
  computed: {
    ...mapGetters([
      'menuActive',
      'clientWidth'
    ]), /* navbar状态获取,影响table宽度 */
    operationList () {
      return this.operation.map(item => {
        return {
          ...item,
          size: 'mini',
          tooltip: true,
          funcProps: {
            ...item.funcProps,
            table: this
          }
        }
      })
    },
    toolbarList () {
      return this.toolbar.map(item => {
        return {
          ...item,
          funcProps: {
            ...item.funcProps,
            table: this
          }
        }
      })
    },
    dialogShow () {
      return this.dialogVisible
    }, /* 判断新增弹窗是否打开 */
    userDialogShow () {
      return this.userDialogVisable
    },
    updateDialogShow () {
      return this.updateDialogVisible
    },
    tableWrapperWidth () {
      this.leftMenuWidth = this.$refs.menuLeft ? this.$refs.menuLeft.clientWidth : this.leftMenuWidth
      return this.clientWidth - (this.menuActive ? 140 : 0) - ((this.clientWidth > 991) ? 70 : 0) - 40 - this.leftMenuWidth
    }
  },
  watch: {
    '$route' (to) {
      const { pageIndex, pageSize, orderBy } = to.query
      this.pageIndex = Number(pageIndex) || 1
      this.pageSize = Number(pageSize) || 10
      // this.filterBy = this.filterTextToFilterBy(filterBy)
      this.orderBy = this.orderTextToOrderBy(orderBy)
      this.getData(this.areaId)
    },
    filterByAlways (val) {
      this.filterBy = [...val]
      this.getData(this.areaId)
    },
    filterTreeText (val) {
      this.$refs.deviceTree.filter(val)
    }
  },
  mounted () {
    expire()
    this.getRelation()
  },
  methods: {
    closeMap () {
      this.dialogTableVisible = 1
    },
    showMap () {
      this.dialogTableVisible = 2
    },
    downloadCSV () {
      this.download('计量器批量导入模板')
      this.$alert('下载的模板请用记事本打开，并按照指定格式填写。保存为UTF-8编码。确认已经提前创建好相关区域', '温馨提示', {
        confirmButtonText: '我清楚了',
        callback: action => {}
      })
    },
    changeOrderBy (data) {
      this.$router.push({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          orderBy: this.orderByToOrderText(data)
        }
      })
    },
    customLabel ({ hname, hno, phone, mobile, addr }) {
      return `${hname} / ${hno} / ${phone} / ${mobile} / ${addr}`
    },
    filterTreeNode (value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    changeFilterBy (data) {
      this.filterBy = [...data, ...this.filterByAlways]
      this.getData(this.areaId)
    },
    getRelation () {
      fetchRelation({
        url: '/relation',
        params: this.relationKeys.join(',')
      }).then(data => {
        this.isRelation = true
        // console.log(data)
        const columnsList = this.columns
        Object.keys(columnsList).map(key => {
          const relation = columnsList[key].relation
          if (data[relation]) {
            columnsList[key].options = [...columnsList[key].optionsInit || [], ...data[relation]].map(option => {
              const label = option[columnsList[key].labelName || 'label']
              const subtext = pinyinInitial(label)
              return {
                value: option.value !== undefined ? option.value : option.id,
                label,
                subtext,
                ...option
              }
            })
          }
        })
        // 加了不允许编辑的字段 updateColumns， 所以加了蛋疼的options，待优化...
        const updateColumns = this.updateColumns
        Object.keys(updateColumns).map(key => {
          const relation = updateColumns[key].relation
          if (data[relation]) {
            updateColumns[key].options = data[relation]
          }
        })
        this.treeData = treeFormat(data.areaId, 'value')
        this.$nextTick(() => {
          this.leftMenuWidth = this.$refs.menuLeft ? this.$refs.menuLeft.clientWidth : 0
        })
        this.$emit('getRelation', columnsList)
        // this.getCollectData()
      })
    },
    getData (id) {
      this.valueCheckAll = []
      this.areaId = id || id !== undefined ? id : this.areaId
      this.isLoading = true
      fetchList({
        resource: this.resource + `?areaId=${this.areaId}`,
        orderBy: this.orderByToOrderText(this.orderBy),
        filterBy: this.filterBy.map(item => {
          if (Object.prototype.toString.call(item.value) === '[object Array]') {
            return item.name + '|' + item.type + '|[' + item.value + ']'
          } else {
            return item.name + '|' + item.type + '|' + item.value
          }
        }).join(';'),
        pageSize: this.pageSize,
        pageIndex: this.pageIndex
      }).then(data => {
        const result = data || {
          data: [],
          recordsFiltered: 0,
          recordsTotal: 0
        }
        this.loading2 = false
        // console.log(data)
        this.tableRender(result)
      })
    },
    getTreeData (data, node) {
      if (!node.childNodes.length) {
        this.areaId = data.value
        this.getData(this.areaId)
      }
    },
    tableRender (data) {
      this.isLoading = false
      this.tableCountData = [].concat(data.data)
      this.recordsFiltered = data.recordsFiltered
      this.recordsTotal = data.recordsTotal
    },
    afterChangeColumn (lists) {
      this.tableCountList = lists
    }, /* 列过滤 */
    filterByToFilterText (filterBy) {
      return filterBy.map(({name, type, value}) => `${name}|${type}|${value}`).join(';')
    },
    filterTextToFilterBy (filterText) {
      if (!filterText) {
        return []
      }
      return filterText.split(';').map(item => {
        const filter = item.split('|')
        return {
          name: filter[0],
          type: filter[1],
          value: valueFormat(filter[2], this.columnsList[filter[0]].dataType)
        }
      })
    },
    orderByToOrderText (orderBy) {
      const _orderBy = orderBy.length ? orderBy : this.orderByInit || []
      return _orderBy.map(({name, sort}) => `${name}|${sort}`).join(';')
    },
    orderTextToOrderBy (orderText) {
      if (!orderText) {
        return []
      }
      return orderText.split(';').map(item => {
        const order = item.split('|')
        return {
          name: order[0],
          sort: order[1]
        }
      })
    },
    pageSizeChange (value) {
      this.$router.push({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          pageSize: value
        }
      })
      this.pageIndexChange(1)
    }, /* 每页显示记录数的修改函数 */
    pageIndexChange (value) {
      this.$router.push({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          pageIndex: value
        }
      })
    },
    getUserOptions: debounce(function (value) {
      if (value) {
        this.searchLoading = true
        fetch({
          url: '/dock/plugin/waterUserList',
          params: {
            key: value,
            pageIndex: 1,
            pageSize: 100
          }
        }).then(data => {
          if (!data.length) this.showNoResult = true
          this.userOptions = data
          this.searchLoading = false
        })
      }
    }, 500, {}),
    // 多删
    handelDeleteAll () {
      const that = this
      if (!this.valueCheckAll.length) {
        this.$swal('error', '请选择批量删除的设备', 'error')
        return
      }
      this.$swal({
        title: '确定删除吗?',
        text: '是否删除所选计量器',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: '删除',
        cancelButtonText: '取消'
      }).then(function (result) {
        if (result) {
          that.deleteAllCheck()
        }
      })
    },
    exportCounter () {
      console.log('开始导出计量设备')
      // 导出计量设备
      fetch({
        url: '/nb/counter/export',
        params: {
          exportDataType: 'ExportDataTypeCounter'
        }
      }).then(data => {
        console.log(data)
        if (data) {
          if (data.id === 0) {
            this.intervalId = setInterval(this.checkExportProcess, 1000)
          } else {
            this.$swal(data.message, '', 'warn')
          }
        } else {
          this.$swal('导出失败!', '', 'error')
        }
      })
      console.log('结束导出计量设备')
    },
    checkExportProcess () {
      fetch({
        url: '/nb/counter/exportCheck',
        params: {
          exportDataType: 'ExportDataTypeCounter'
        }
      }).then(data => {
        console.log(data)
        if (data) {
          console.log(data.message + ',' + data.id)
          if (data.id !== 6) {
            const status = data.id === 0 ? 'success' : 'warn'
            this.$swal(data.message, '', status)
            clearInterval(this.intervalId)
            if (status === 'success') {
              this.download('ExportDataTypeCounter')
            }
          }
        } else {
          clearInterval(this.intervalId)
          this.$swal('导出失败!', '', 'error')
        }
      })
    },
    download (exportDataType) {
      axios({
        method: 'POST',
        url: '/nb/counter/download?exportDataType=' + exportDataType,
        data: {},
        responseType: 'arraybuffer'
      }).then(response => {
        console.log(response)
        if (!response) {
          return
        }
        let contentDispostion = response.headers['content-disposition'].split(';')[1]
        let fileName = decodeURIComponent(contentDispostion.split('=')[1])
        console.log(contentDispostion)
        let url = window.URL.createObjectURL(new Blob([response.data]))
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
      }).catch(error => {
        console.log(error)
      })
    },
    // 导出抄表数据
    exportCounterSelect () {
      var startTimeStr = ''
      var endTimeStr = ''
      var startTime
      var endTime
      if (this.areaId === '') {
        this.$message({
          message: '请选择区域',
          type: 'warning'
        })
        return
      }
      if (this.exportDate == null || this.exportDate === '') {
        startTime = new Date()
        endTime = new Date()
      } else {
        startTime = new Date(this.exportDate[0])
        endTime = new Date(this.exportDate[1])
      }
      // 年
      var startYear = startTime.getFullYear()
      var endYear = endTime.getFullYear()
      // 月
      var startMonth = startTime.getMonth()
      var endMonth = endTime.getMonth()
      startMonth = startMonth + 1
      endMonth = endMonth + 1
      if (startMonth < 10) startMonth = '0' + startMonth
      if (endMonth < 10) endMonth = '0' + endMonth
      // 日
      var startDate = startTime.getDate()
      var endDate = endTime.getDate()
      if (startDate < 10) startDate = '0' + startDate
      if (endDate < 10) endDate = '0' + endDate
      // 时
      var startHour = startTime.getHours()
      var endHour = endTime.getHours()
      if (startHour < 10) startHour = '0' + startHour
      if (endHour < 10) endHour = '0' + endHour
      // 分
      var startMin = startTime.getMinutes()
      var endMin = endTime.getMinutes()
      if (startMin < 10) startMin = '0' + startMin
      if (endMin < 10) endMin = '0' + endMin
      // 秒
      var startSec = startTime.getSeconds()
      var endSec = endTime.getSeconds()
      if (startSec < 10) startSec = '0' + startSec
      if (endSec < 10) endSec = '0' + endSec
      startTimeStr = startYear + '-' + startMonth + '-' + startDate + ' ' + startHour + ':' + startMin + ':' + startSec
      endTimeStr = endYear + '-' + endMonth + '-' + endDate + ' ' + endHour + ':' + endMin + ':' + endSec

      // 导出抄表数据
      const link = document.createElement('a')
      link.href = 'wwis/meterPayload/data/totalData/export?counterIds=' + this.valueCheckAll.toString() + '&areaId=' + this.areaId + '&startTime=' + startTimeStr + '&endTime=' + endTimeStr  // 文件url
      link.click()
      setTimeout(this.successMsg, 2000)
    },
    successMsg () {
      this.$swal('导出成功!', '', 'success')
    },
    deleteAllCheck () {
      fetch({
        method: 'delete',
        url: '/nb/counter/batch',
        data: {
          counterIdArray: this.valueCheckAll
        }
      }).then(res => {
        if (res) {
          this.$swal('删除成功!', '', 'success')
          this.valueCheckAll = []
        }
        this.getData()
      })
    },
    checkGroupValue (value) {
      this.valueCheckAll = value
    },
    // 上传
    beforeUpload () {
      this.loading2 = true
      this.uploadHeader = httpHeader({
        headers: { 'Gddx-Access-AppId': 'web' }
      }, this.$moment().format('x'))
      return true
    },
    renderData (response) {
      const status = response.code === 0 ? 'success' : 'error'
      const message = response.code === 0 ? '导入成功' : '导入失败'
      this.$swal(message, response.message, status)
      this.getData()
    }
  }
}

</script>
<style scoped lang="sass">
.main
  padding: 20px
  display: flex
  flex-direction: column
  flex: 1
  height: 100%
.table-wrapper
  display: flex
  flex-direction: column
  flex: 1
.table-top
  margin-bottom: 10px
  .toolbar
    float: left
    margin-right: 12px
  .filter-box
    float: right
    margin-left: 12px
    //- max-width: 80%
  .customToolbar
    margin-bottom: 10px
.pagination
  flex: 1
  padding-top: 12px
  text-align: right
.column-filter
  float: left
  padding-top: 12px
.table-footer
  display: flex
  justify-content:  space-between
  align-item: center
.flexBody
  flex: 1
  .telnetMenu
    height: calc(100% - 45px)
  .filter-tree
    height: calc(100% - 36px)
    overflow: scroll
  .telnetTable
    height: calc(100% - 50px)
    overflow: hidden
.blockquote:before
  content: '' !important
  .form
    border: 1px solid #e8e8e8
.blockquote-button
  margin-bottom: 10px
.userMultiform
  text-align: center
  margin-bottom: 10px
.multOption
  line-height: 40px
.headerBar
  display: flex
  align-item: center
  height: 48px
  .header-bottom
    margin: 10px
    margin-left: 0px
    .download
      color: #5e5e5e
.text-danger
  font-size: 20px
  line-height: 20px
  padding-right: 4px
  vertical-align: text-top
</style>



// WEBPACK FOOTER //
// counter.vue?f1d455e6